export const typeIcons = {
  '0': 'simple-icon-credit-card',
  '1': 'iconsminds-heart',
  '21': 'iconsminds-first-aid',
  '22': 'iconsminds-scale',
  '23': 'iconsminds-shop',
  '31': 'iconsminds-car',
  '32': 'iconsminds-home',
  '33': 'iconsminds-dog',
};

export const reactionImages = [
  'like.png',
  'love.png',
  'wow.png',
  'haha.png',
  'sad.png',
  'angry.png',
];

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
